<template>
    <!-- 页眉 -->
    <header-index />

    <!-- 头部背景区域 -->
    <div
        class="category-banner"
        style="background-image: url('https://images.leaflypackaging.com/profile/upload/2025/11/24/packaging_banner_20251124100330A062.webp');
            background-size: cover;
            background-position: center;">
        <div class="container mx-auto px-4 h-[100%] flex flex-col justify-center">
            <div class="pb-2 ">
                <h1 class="leafly-page-title">One for all solution,for custom printed packaging</h1>
                <p class="leafly-page-second-title">Get everything custom packaging your business needs all in one place.</p>
            </div>

            <drawdownMenu />
        </div>
    </div>

    <!-- 分类和产品区域 -->
    <div class="bg-gray-50 py-8">
        <div class="container mx-auto  px-4 w-00%">
            <!-- 二级导航目录 -->
            <div ref="navContainerRef" class="custom-scrollbar-container flex justify-between mb-8 gap-4 overflow-x-auto text-center align-middle" @mousedown="handleMouseDown" @mousemove="handleMouseMove" @mouseup="handleMouseUp" @mouseleave="handleMouseUp" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd" :class="{ 'is-dragging': isDragging }">
                <nuxt-link v-for="item in navItemList" :to="item.linkUrl" :key="item.id" class="flex-1 py-6 text-center text-[1.3rem] font-weight-600 transition-colors rounded-md min-w-[150px] hover:text-green-600 hover:border-green-600" :class="item.linkUrl === route.path ? 'border-2 border-green-600 text-green-600' : 'bg-white text-gray-700 border border-gray-200 hover:border-gray-300'" @click="handleLinkClick">
                    {{ item.name }}
                </nuxt-link>
            </div>

            <!-- 产品卡片区域 -->
            <div class="w-full">
                <!-- 产品网格 -->
                <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
                    <div v-for="(article, index) in articlesPage.rows" :key="index" class="bg-white border border-gray-100 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all">
                        <!-- 产品标签 -->
                        <!-- <div v-if="article.tagsList.length > 0" class="absolute m-3 bg-green-500 text-white text-xs px-2 py-1 rounded-md">
                            {{ article.tagsList[0].name }}
                        </div> -->

                        <!-- 产品图片 -->
                        <div class="relative w-full pt-[100%]">
                            <img 
                                :src="cmsUtils.isEmpty(article.imageUrl)?'/images/xxx.jpg':article.imageUrl!.split(',')[0]" 
                                :alt="article.title" 
                                class="absolute top-0 left-0 w-full h-full object-cover" 
                                loading="lazy"
                                width="400"
                                height="400"
                            />
                        </div>

                        <!-- 产品信息 -->
                        <div class="p-4 flex flex-col">
                            <div class="h-[136px]">
                                <h3 class="text-base  mb-1 line-clamp-2">
                                    <nuxt-link :to="article.fullUrl" class="leafly-article-item-title line-clamp-2  hover:text-green-600">{{ article.title }}</nuxt-link>
                                </h3>
                                <p class="line-clamp-3  leafly-article-item-content">{{ article.description }}</p>
                            </div>
                            <nuxt-link :to="article.fullUrl" class="block w-full bg-green-600 text-white text-center py-2 rounded-md text-sm font-weight-400 hover:bg-green-700 transition-colors mt-4">View Product</nuxt-link>
                        </div>
                    </div>
                </div>

                <!-- 产品结束提示 -->
                <div class="flex justify-center mt-12">
                    <div class="flex items-center space-x-1">
                        <page-icon :page-num="props.pageNum" :page-size="props.pageSize" :total="articlesPage.total!" />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 页脚 -->
    <footer-index />
</template>

<script setup lang="ts">
    import { ref, onMounted, onUnmounted, watch } from 'vue'
    import type { Category, NavItemVo, Tags, Article, Page, ArticleListPo } from '~/types';
    import headerIndex from '../../components/header/header-index.vue'
    import footerIndex from '../../components/footer/footer-index.vue'
    import pageIcon from '../../components/common/pageIcon.vue';
    import cmsConfig from '~/cmsConfig';
    import cmsUtils from '~/utils/cmsUtils';
    import drawdownMenu from '../../components/category/packaging/drawdonwMenu.vue';

    const route = useRoute()

    const cmsInfo = await cmsUtils.getCmsInfo()
    const navItemList = ref<NavItemVo[]>(cmsUtils.getNavItemTreeByNavIndex("index_category", cmsInfo) as NavItemVo[])

    // 拖拽滚动相关状态
    const navContainerRef = ref<HTMLElement | null>(null)
    const isDragging = ref(false)
    const startX = ref(0)
    const scrollLeft = ref(0)
    const hasMoved = ref(false)

    // 鼠标事件处理
    const handleMouseDown = (e: MouseEvent) => {
        if (!navContainerRef.value) return
        isDragging.value = true
        hasMoved.value = false
        startX.value = e.pageX - navContainerRef.value.offsetLeft
        scrollLeft.value = navContainerRef.value.scrollLeft
        navContainerRef.value.style.cursor = 'grabbing'
        e.preventDefault()
    }

    const handleMouseMove = (e: MouseEvent) => {
        if (!isDragging.value || !navContainerRef.value) return
        e.preventDefault()
        const x = e.pageX - navContainerRef.value.offsetLeft
        const walk = (x - startX.value) * 2 // 滚动速度倍数
        navContainerRef.value.scrollLeft = scrollLeft.value - walk
        hasMoved.value = true
    }

    const handleMouseUp = () => {
        if (!navContainerRef.value) return
        isDragging.value = false
        navContainerRef.value.style.cursor = 'grab'
        // 鼠标抬起后如果没有实际拖动，保持 hasMoved 为 false，防止影响后续点击
        if (!isDragging.value) {
            // 如果只是点了一下，没有触发位移，hasMoved 会保持为 false
            // 如果之前有拖动，在下一次点击中会通过 handleLinkClick 重置
        }
    }

    // 触摸事件处理（移动端）
    const handleTouchStart = (e: TouchEvent) => {
        if (!navContainerRef.value || !e.touches[0]) return
        isDragging.value = true
        hasMoved.value = false
        startX.value = e.touches[0].pageX - navContainerRef.value.offsetLeft
        scrollLeft.value = navContainerRef.value.scrollLeft
    }

    const handleTouchMove = (e: TouchEvent) => {
        if (!isDragging.value || !navContainerRef.value || !e.touches[0]) return
        const x = e.touches[0].pageX - navContainerRef.value.offsetLeft
        const walk = (x - startX.value) * 2
        navContainerRef.value.scrollLeft = scrollLeft.value - walk
        hasMoved.value = true
    }

    const handleTouchEnd = () => {
        isDragging.value = false
        // 触摸结束后如果只是点按而非拖动，hasMoved 会保持为 false
    }

    // 处理链接点击，如果发生了拖拽则不跳转
    const handleLinkClick = (e: MouseEvent) => {
        if (hasMoved.value) {
            e.preventDefault()
            e.stopPropagation()
            hasMoved.value = false
        }
    }

    // 接收分类数据
    const props = withDefaults(defineProps<{
        category: Category | null
        tagsList?: Tags[]
        pageSize?: number
        pageNum?: number
    }>(), {
        tagsList: () => [],
        pageSize: 12,
        pageNum: 1
    })

    const childCategoryIds = cmsUtils.getChildCategoryIds(props.category!.id, cmsInfo);
    const allCategoryIds = [props.category!.id, ...childCategoryIds];
    const tagsIdsList:number[][] = [];
    props.tagsList.forEach(item => {
        const childTagsIds = [...cmsUtils.getChildTagsIds(item!.id, cmsInfo),item.id]
        tagsIdsList.push(childTagsIds)
    })

    // 文章列表数据
    const articlesPage = ref<Page<Article>>({ rows: [], total: 0, pageNum: 1, pageSize: 12 })

    // 获取文章列表的函数
    const fetchArticles = async (pageNum: number) => {
        const articleListPo: ArticleListPo = {
            "websiteId": cmsInfo!.website.id,
            "categoryIds": allCategoryIds,
            "tagsIdsList": tagsIdsList,
            "orderType":"top",
            "pageNum": pageNum,
            "pageSize": props.pageSize
        }

        const response = await useHttp("/nuxt/article/list", {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: articleListPo
        }) as Page<Article>;
        
        response.rows.forEach((article: Article) => {
            let articleCategory: Category = cmsInfo.category.find(item => item.id == article.categoryId)!;
            article.fullUrl = cmsUtils.appendCategoryUrl(articleCategory, cmsInfo, "/" + article.titleUrl );
        });

        articlesPage.value = response
    }

    // 初始加载
    await fetchArticles(props.pageNum)

    // 监听 pageNum 变化，重新获取数据
    watch(() => props.pageNum, async (newPageNum) => {
        await fetchArticles(newPageNum)
    })

    // JSON-LD 结构化数据（产品列表）
    const baseUrl = (cmsInfo.website.https ? 'https://' : 'http://') + cmsInfo.website.domain
    const canonicalUrl = baseUrl + route.path.replace('.html','')
    useHead({
        script: [
            {
                type: 'application/ld+json',
                innerHTML: JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'ItemList',
                    itemListElement: articlesPage.value.rows.map((article, index) => ({
                        '@type': 'ListItem',
                        position: (props.pageNum - 1) * props.pageSize + index + 1,
                        item: {
                            '@type': 'Product',
                            name: article.title,
                            url: baseUrl + article.fullUrl,
                            ...(article.imageUrl ? { image: article.imageUrl.split(',')[0] } : {}),
                            ...(article.sku ? { sku: article.sku } : {}),
                            ...(article.description ? { description: article.description } : {})
                        }
                    })),
                    numberOfItems: articlesPage.value.total,
                    name: props.category?.title || props.category?.name,
                    ...(props.category?.description ? { description: props.category.description } : {}),
                    url: canonicalUrl
                })
            }
        ]
    })
</script>

<style scoped lang="scss">

    .banner{
        background-image:  var(--bg-image);
        background-size: cover;
        background-position: center;
    }

    /* 文本截断样式 */
    .line-clamp-2 {
        display: -webkit-box;
        -line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    .line-clamp-3 {
        display: -webkit-box;
        -line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }

    /* 确保图片容器和内容区域有固定高度 */
    .h-12 {
        height: 3rem;
    }

    .h-14 {
        height: 3.5rem;
    }

    /* 自定义滚动条样式 */
    .custom-scrollbar-container {
        cursor: grab;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;

        /* Firefox 滚动条样式 */
        scrollbar-width: thin;
        scrollbar-color: transparent transparent;

        /* 默认隐藏滚动条 */
        &::-webkit-scrollbar {
            height: 6px;
        }

        &::-webkit-scrollbar-track {
            background: transparent;
        }

        &::-webkit-scrollbar-thumb {
            background: transparent;
            border-radius: 3px;
            transition: background 0.3s ease;
        }

        /* 鼠标悬停时显示滚动条 */
        &:hover {
            scrollbar-color: #16a34a transparent; /* green-600 */

            &::-webkit-scrollbar-thumb {
                background: #16a34a; /* green-600 */
            }

            &::-webkit-scrollbar-thumb:hover {
                background: #15803d; /* green-700 */
            }
        }

        /* 拖拽时的样式 */
        &.is-dragging {
            cursor: grabbing;
        }

        /* 链接样式 */
        a {
            user-select: none;
            -webkit-user-select: none;
            -moz-user-select: none;
            -ms-user-select: none;
        }

    }
</style>
